module.exports = __webpack_public_path__ + "img/HA2504-P13A.6efe3374.jpg";